<div [ngClass]="{'invalid' : !isValid}" [style.width]="cellWidth" [style.height]="cellHeight" [innerHTML]="fieldValue | safeHtml" ></div>

